module.exports = __webpack_public_path__ + "img/progress-icon.4d994c9d.png";